import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibility-header',
  templateUrl: './accessibility-header.component.html',
  styleUrls: ['./accessibility-header.component.scss']
})
export class AccessibilityHeaderComponent implements OnInit {
  @Input() header: string;

  constructor() { }

  ngOnInit(): void {
  }

}
